'use client';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useTheme } from '@mui/material/styles';

type Props = {
  categoryId: string | null;
  setCategoryId: (categoryId: string | null) => void;
  customerSetting: CustomerSetting;
};

export const CategorySelect: React.FC<Props> = ({
  categoryId,
  setCategoryId,
  customerSetting
}) => {
  const theme = useTheme();

  return (
    <>
      <InputLabel
        id="searchbox-category-label"
        htmlFor="searchbox-category"
        sx={theme.typography.body2}
      >
        カテゴリで絞り込む
      </InputLabel>
      <Select
        labelId="searchbox-category-label"
        fullWidth
        size="small"
        inputProps={{
          id: 'searchbox-category',
          sx: {
            color: categoryId === null ? theme.palette.text.disabled : undefined
          }
        }}
        value={categoryId === null ? 'null' : categoryId}
        onChange={(e) => {
          if (e.target.value === 'null') {
            setCategoryId(null);
          } else {
            setCategoryId(e.target.value);
          }
        }}
      >
        <MenuItem value="null">カテゴリを選択</MenuItem>
        {customerSetting.categories.map((category) => (
          <MenuItem key={category.id} value={category.id.toString()}>
            {category.name}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};
